<template>
    <signView :viewType="1">
        <template  v-slot:mainCenter>
            <div class="login_box">
                <div class="back_box">
                    <div class="back_click" @click="$router.push('/login')">
                        <span class="left_icon"></span>
                        Back to login
                    </div>
                </div>
                <div class="login_item">
                    <div class="login_from" v-if="!isSend">
                        <h1 class="centerText bold_primaryText" style="margin-bottom:50px">Forgot password</h1>
                        <el-input autocomplete="off" v-model="email" class="myLogin_input" maxlength="100" 
                        :class="{'is-error':emptyEmail||!isSuccessFormat}" @blur="valid(1)" 
                        placeholder="Email address"></el-input>
                        <transition name="el-fade-in">
                            <p v-show="!isSuccessFormat" class="error_msg">The email format entered is incorrect.</p>
                        </transition>
                        <div class="default_Btn" :class="{'loading_btn':loading}" @click="sendEmail">Send
                            <i v-show="loading" class="el-icon-loading my_loading_icon"></i>
                        </div>
                    </div>
                    <div class="login_from" v-else>
                        <h1 class="centerText bold_primaryText" style="margin-bottom:50px">Forgot password</h1>
                        <div class="send_email">Please check your email for the link</div>
                        <div class="default_Btn send_btn" @click="$router.push('/login')">Back to login</div>
                    </div>
                    <img src="https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/4c70d3514be74e4e8ba7c4b79d089e44.png" class="login_icon" alt="">
                </div>
            </div>
        </template>
    </signView>
</template>

<script>
import api from '../../api/login'
import signView from '../common/sign-view.vue'
export default {   
    components:{signView},
    data() {
        return {

            isSuccessFormat:true,
            loading:false,
            email:'',
            emptyEmail:false,
            isSend:false,
        }
    },
    methods: {
        valid(key){
            switch (key) {
                case 1:
                    this.emptyEmail = this.email?false:true
                    if(!this.emptyEmail){
                        this.emptyEmail = false
                        this.isSuccessFormat = Utils.isEmail(this.email)
                    }
                    break;
            }
        },
        sendEmail(){
            if(this.loading) return
            this.valid(1)
            if(this.emptyEmail||!this.isSuccessFormat) return
            this.loading = true
            // const pat = {
            //     email:this.email
            // }
            const pat = new FormData()
            pat.append('email',this.email)
            api.forgotPassword(pat,res=>{
                const {code,message} = res.data;
                this.loading = false
                if(code == 200){
                    Utils.alert('',message,'success')
                    this.isSend = true
                }else{
                    Utils.alert('',message,'error')
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.login_box{
    min-height: calc(100vh - 128px);
    padding-top: 56px;
    // overflow: hidden;
    position: relative;
    .back_box{
        position:relative;
        width: 1220px;
        margin: 0 auto;
        font-size: 16px;
        font-family: Assistant-SemiBold, Assistant;
        font-weight: 600;
        color: #FFFFFF;
        .back_click{
            cursor: pointer;
            width: 150px;
            display: flex;
            align-items: center;
            .left_icon{
                margin-right: 7px;
                height: 12px;
                width: 7px;
                background-image: url('../../assets/login/left.png');
                background-repeat: no-repeat;
                background-size: contain;
            }
        }
    }
    .login_item{
        display: flex;
        width: 1220px;
        margin: 0 auto;
        .login_from{
            width: 445px;
            min-width: 445px;
            margin-top: 156px;
            .default_Btn{
                margin-top: 24px;
            }
            .send_email{
                border-radius: 4px;
                width: 445px;
                height: 55px;
                background: #44423f;
                font-size: 17px;
                font-family: Assistant-SemiBold, Assistant;
                font-weight: 600;
                color: #c5c4c3;
                line-height: 55px;
                padding: 0 15px;
                user-select: none;
            }
            .send_btn{
                background-color: #3a3835;
                border: 2px solid #F8A4AE;
                color: #F8A4AE;
            }
            /deep/{
                .myLogin_input{
                    height: 55px;
                    .el-input__inner{
                        height: 55px;
                        line-height: 55px;
                        background: #4e4c4a;
                        border-color: #4e4c4a;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .login_icon{
            margin-left: auto;
            width: 740px;
            height: 722px;
            margin-right: -89px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/sign/forget-password.vue